module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid16_960x869.eb7aaf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid16_960x869.jpg
// module id = M0YT
// module chunks = 0